module.exports = __webpack_public_path__ + "static/product-l0810-olive-drab-8adef9949708e7ab92ada21653415b6e.png";